import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, concatMap, map, switchMap } from 'rxjs/operators';
import { EMPTY, of } from 'rxjs';

import * as ScheduledReportsActions from '../actions/scheduled-reports.actions';
import { ReportsService } from '../../reports/reports.service';
import { MatDialog } from '@angular/material/dialog';
import { NotificationService } from '@fc-core';
import { getErrorMessage } from '@fc-core/services/notification.utils';

@Injectable()
export class ScheduledReportsEffects {
  loadScheduledReports$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(ScheduledReportsActions.loadScheduledReports),
      concatMap(() =>
        this.reportsService.getScheduleReports().pipe(
          map((scheduleList) =>
            ScheduledReportsActions.loadScheduledReportsSuccess({
              scheduleList,
            }),
          ),
          catchError((error) =>
            of(ScheduledReportsActions.loadScheduledReportsFailure({ error })),
          ),
        ),
      ),
    );
  });

  createScheduledReports$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(ScheduledReportsActions.addReportSchedule),
      concatMap(({ schedule }) =>
        this.reportsService.addScheduleReports(schedule).pipe(
          map((scheduleRes) => {
            this.notifications.showSuccess('Report successfully Created');
            this.dialog.closeAll();
            return ScheduledReportsActions.addReportScheduleSuccess({
              schedule: scheduleRes,
            });
          }),
          catchError((error) =>
            of(ScheduledReportsActions.loadScheduledReportsFailure({ error })),
          ),
        ),
      ),
    );
  });
  deleteScheduledReports$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(ScheduledReportsActions.deleteScheduleReport),
      concatMap(({ id }) =>
        this.reportsService.deleteScheduleReports(id).pipe(
          map(() => {
            this.notifications.showSuccess('Report successfully deleted');
            this.dialog.closeAll();
            return ScheduledReportsActions.deleteScheduleReportSuccess({
              id,
            });
          }),
          catchError((error) =>
            of(ScheduledReportsActions.loadScheduledReportsFailure({ error })),
          ),
        ),
      ),
    );
  });
  updateScheduledReports$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(ScheduledReportsActions.updateSchedule),
      concatMap(({ schedule }) =>
        this.reportsService.updateScheduleReport(schedule).pipe(
          map((scheduleResp) => {
            this.notifications.showSuccess('Report successfully updated');
            this.dialog.closeAll();
            return ScheduledReportsActions.updateScheduleSuccess({
              schedule: scheduleResp,
            });
          }),
          catchError((error) =>
            of(ScheduledReportsActions.loadScheduledReportsFailure({ error })),
          ),
        ),
      ),
    );
  });

  scheduledReportsError$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(ScheduledReportsActions.loadScheduledReportsFailure),
        switchMap(({ error }) => {
          this.notifications.showError(getErrorMessage(error));
          return EMPTY;
        }),
      ),
    { dispatch: false },
  );

  constructor(
    private actions$: Actions,
    private reportsService: ReportsService,
    private dialog: MatDialog,
    private notifications: NotificationService,
  ) {}
}
